import Collection from './collection.js';
import Attachment from 'newModels/attachment.js';
import Taggable from './mixins/taggable.js';

export default class Attachments extends Taggable(Collection) {
    url() {
        if (this.attachable) {
            return `${this.attachable.url()}/attachments`;
        }

        return '/Attachments';
    }

    // Note that attachable can be any model. Careful on what the server
    // supports.
    initialize(models, {attachable = null}) {
        super.initialize(...arguments);
        this.model = Attachment;
        this.attachable = attachable;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/attachments.js